import React from 'react'

export default function Titlebar() {
  return (
    <div className="titlebar">
      <h1>Drosophila Lab</h1>
      <h6>An interactive genetics lab by <a href="https://github.com/eaculb">Elizabeth Culbertson</a></h6>
    </div>
  )
}
